import { omdApi } from 'bus/api';

import { PayloadRequest } from 'types/requestTypes';

import { ContractorDriverPumpPriceCreate, ContractorDriverPumpPriceDetail } from './types';

const request = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getContractorDriverPumpPriceDetail: builder.query<ContractorDriverPumpPriceDetail, PayloadRequest>({
      query: (data) => ({
        url: `/v1/ContractorDriverPumpPrice/${data.id}/details`,
      }),
    }),
    changeContractorDriverPumpPrice: builder.mutation<void, ContractorDriverPumpPriceDetail>({
      query: (data) => ({
        url: `/v1/ContractorDriverPumpPrice/${data.id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    createContractorDriverPumpPrice: builder.mutation<void, ContractorDriverPumpPriceCreate>({
      query: (data) => ({
        url: '/v1/ContractorDriverPumpPrice',
        method: 'POST',
        body: data,
      }),
    }),
    deleteContractorDriverPumpPrice: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/ContractorDriverPumpPrice/${data.id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useChangeContractorDriverPumpPriceMutation,
  useCreateContractorDriverPumpPriceMutation,
  useDeleteContractorDriverPumpPriceMutation,
  useGetContractorDriverPumpPriceDetailQuery,
  useLazyGetContractorDriverPumpPriceDetailQuery,
} = request;
